import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "react-router-dom";

import { UiProvider } from "@/components/ui/feedback";
import { queryClient } from "@/lib/query-client";
import { router } from "@/routes";

export function App() {
	return (
		<QueryClientProvider client={queryClient}>
			<UiProvider>
				<RouterProvider router={router} />
			</UiProvider>
			<ReactQueryDevtools initialIsOpen={false} />
		</QueryClientProvider>
	);
}
